import AsyncStorage from '@react-native-async-storage/async-storage'
import type { User } from '@pff-consumer/schema'
import { getUniqueDeviceIdFromStorage, getTokenFromStorage, getUserFromStorage } from '@pff-consumer/utils'
import { useEffect, useState } from 'react'
import { debounce } from 'lodash'

import { useUpsertDeviceMutation } from './account-api'

export const useAccountStorage = () => {
  const [user, setUser] = useState<User>()
  const [token, setToken] = useState<string>()
  const [uniqueDeviceId, setUniqueDeviceId] = useState<string>()
  const [isReady, setIsReady] = useState<boolean>(false)

  useEffect(() => {
    const init = async () => {
      const storedUser = await getUserFromStorage()
      const storedToken = await getTokenFromStorage()
      const storedUniqueDeviceId = await getUniqueDeviceIdFromStorage()

      if (storedUser && storedToken) {
        setUser(storedUser)
        setToken(storedToken)
      }
      if (storedUniqueDeviceId) {
        setUniqueDeviceId(storedUniqueDeviceId)
      }

      setIsReady(true)
    }
    init()
  }, [])

  return {
    isReady,
    token,
    uniqueDeviceId,
    user,
  }
}

const upsertDeviceDebounced = debounce(async (upsertDevice: () => any) => {
  const deviceSavedStatus = await AsyncStorage.getItem('@device_id_persisted')

  if (deviceSavedStatus !== 'true') {
    const savedDevice: any = await upsertDevice()

    if (savedDevice?.data?.userId) {
      await AsyncStorage.setItem('@device_id_persisted', 'true')
    }
  }
}, 3000)

export const usePersistDeviceToBackend = () => {
  const [upsertDeviceMutation, { isLoading }] = useUpsertDeviceMutation()

  async function upsertDevice({ deviceId, systemName }: { deviceId: string; systemName: string }) {
    if (!isLoading) {
      upsertDeviceDebounced(() => upsertDeviceMutation({ deviceId, systemName }))
    }
  }

  return {
    upsertDevice,
  }
}
